/* eslint max-len: off */
import React from 'react';
import {Icon} from '../createSvg';
import {IconProps} from '../types';

export const Ebanx = (props: IconProps) => (
  <Icon {...props}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M4,2 L13.2318481,9 L19.9582654,2.24579673 C20.0006662,2.20308203 20.011855,2.14111837 19.9867783,2.08789195 C19.9617016,2.03466552 19.9051069,2.0002528 19.8425553,2.00019648 L4,2.00019648 L4,2 Z"
        fill="#7B7B7B"
        fillRule="nonzero"
      />
      <path
        d="M4,22 L13.2317353,15 L19.9580705,21.7539999 C20.0006143,21.7967035 20.0118916,21.8587568 19.986797,21.9120661 C19.9617023,21.9653755 19.9050003,21.9998192 19.8423618,21.9998035 L4,21.9998035 L4,22 Z"
        fill="#7B7B7B"
        fillRule="nonzero"
      />
      <path
        d="M4.29037726,2.03807006 L16.9345506,11.8686661 C17.0218165,11.9364647 17.0218165,12.0635352 16.9345506,12.1315418 L4.29037726,21.9619298 C4.23711849,22.0032389 4.16368663,22.0116688 4.10166275,21.983594 C4.03963887,21.9555192 4,21.8959447 4,21.830492 L4,2.1697159 C4,2.10422559 4.03952296,2.0445778 4.10156432,2.01645064 C4.16360568,1.98832348 4.23708792,1.99673733 4.29037726,2.03807006 Z"
        fill="#000000"
        fillRule="nonzero"
      />
    </g>
  </Icon>
);
